import script from "./authLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./authLayout.vue?vue&type=script&setup=true&lang=js"

import "./authLayout.vue?vue&type=style&index=0&id=eed0b764&lang=scss&scoped=true"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eed0b764"]])

export default __exports__